export default __webpack_public_path__ + "static/media/yellowgreen.9adbb3f0.svg";